import { createActions, createReducer } from 'reduxsauce';
import { cloneDeep, forEach, set } from 'lodash';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	loading : {
		list       : false,
		details    : false,
		activeJobs : false,
		officers   : false,
		activity   : false,
		locations  : false,
	},
	data    : [],
	details : {
		data       : {},
		activeJobs : {
			data       : [],
			totalCount : 0,
			filters    : {
				displayCount : 10,
				pageNumber   : 1,
			},
		},
		jobHistory : {
			data       : [],
			totalCount : 0,
			filters    : {
				displayCount : 10,
				pageNumber   : 1,
			},
		},
		activity : {
			data       : [],
			totalCount : 0,
			filters    : {
				pagingToken  : null,
				displayCount : 10,
				hasNext      : false,
			},
		},
		locations : {
			data       : [],
			totalCount : 0,
			filters    : {
				displayCount : 10,
				pageNumber   : 1,
			},
		},
	},
	filters : {
		displayCount : 15,
		pageNumber   : 1,
		totalCount   : 0,
	},
	pendingInvitation : [],
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	setLoading               : ['property', 'value'],
	updateStoreProperties    : ['collection'],
	updateDetailsProperties  : ['collection'],
	resetCoordinatorsValues  : ['coordinatorFieldArray'],
	updateCoordinatorsFilter : ['propertyObject'],
	receiveSectionData       : ['section', 'data', 'totalCount'],
	updateSectionFilters     : ['section', 'propertyObject'],
	resetActivityData        : [],
}, { prefix : '@coordinators/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.SET_LOADING] : (state, { property, value }) => ({
		...state,
		loading : {
			...state.loading,
			[property] : value,
		},
	}),

	[Types.UPDATE_STORE_PROPERTIES] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, (value, property) => set(newState, property, value));

		return newState;
	},
	[Types.UPDATE_DETAILS_PROPERTIES] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, (value, property) => set(newState.details, property, value));

		return newState;
	},
	[Types.RESET_COORDINATORS_VALUES] : (state, { coordinatorFieldArray = null }) => {
		const newState = cloneDeep(state);
		if (coordinatorFieldArray) {
			forEach(coordinatorFieldArray, (item) => {
				newState[item] = INITIAL_STATE[item];
			});
			return newState;
		} return INITIAL_STATE;
	},
	[Types.UPDATE_COORDINATORS_FILTER] : (state, { propertyObject }) => {
		const newState = cloneDeep(state);

		forEach(propertyObject, (item, key) => {
			newState.filters[key] = item;
		});

		return newState;
	},

	[Types.RECEIVE_SECTION_DATA] : (state, { section, data, totalCount }) => ({
		...state,
		details : {
			...state.details,
			[section] : {
				...state.details[section],
				data,
				totalCount,
			},
		},
	}),

	[Types.UPDATE_SECTION_FILTERS] : (state, { section, propertyObject }) => {
		const newState = cloneDeep(state);

		forEach(propertyObject, (value, property) => {
			set(newState, `details.${section}.filters.${property}`, value);
		});

		return newState;
	},

	[Types.RESET_ACTIVITY_DATA] : (state) => {
		const newState = cloneDeep(state);
		newState.details.activity = cloneDeep(INITIAL_STATE.details.activity);
		return newState;
	},
});

export default Creators;
